<template>
  <fieldset class="fieldset p-4 bg-lightblue" :id="compId">
    <legend :for="compId">{{ $t(i18nLabel) }}&nbsp;<abbr :title="$t('common.form.required')" v-if="isRequired()"><sup>*</sup></abbr></legend>
    <ul class="row">
      <li v-for="(weekday, index) in availableWeekdays()" :key="weekday" class="col">
        <input :id="compId + index" type="checkbox" v-bind:class="{ 'form-error-focusable': validation.$error }" :checked="isChecked(weekday)" @change="onChange(weekday, $event.target.checked)" class="form-check-input" />
        <label :for="compId + index">{{ $t('common.days.' + weekday) }}</label>
      </li>
    </ul>
    <control-error-message :validation="validation" :i18nLabel="i18nLabel" />
    <slot></slot>
  </fieldset>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import _uniqueId from 'lodash.uniqueid'
import { Validation } from '@vuelidate/core'
import { all } from '@/utils/WeekdayUtils'
import ControlErrorMessage from './ControlErrorMessage.vue'
import { CreateTimeSlotDefinitionDaysOfWeekEnum } from '@/generated/openapi'

export default defineComponent({
  components: { ControlErrorMessage },
  name: 'ControlWeekDays',
  props: {
    i18nLabel: { type: String, required: true },
    validation: { type: Object as PropType<Validation>, required: true },
    modelValue: { type: Set as PropType<Set<CreateTimeSlotDefinitionDaysOfWeekEnum>>, required: true }
  },
  data() {
    return {
      compId: _uniqueId('control-week-days-')
    }
  },
  methods: {
    availableWeekdays(): string[] {
      return [...all()]
    },
    isChecked(str: string) {
      return !![...this.modelValue].find(weekDay => weekDay === str)
    },
    isRequired() {
      return !!this.validation.requiredWeekDay
    },
    onChange(weekday: string, checked: boolean) {
      const clone = new Set([...this.modelValue])
      if (checked) {
        clone.add(weekday as CreateTimeSlotDefinitionDaysOfWeekEnum)
      } else {
        clone.delete(weekday as CreateTimeSlotDefinitionDaysOfWeekEnum)
      }
      this.$emit('update:modelValue', clone);
      this.validation.$touch();
    }
  }
});
</script>
<style scoped>
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: inherit;
    color: inherit;
    white-space: normal;
    position: relative;
    top:24px;
    left: 0;
    margin-bottom: 18px;
}
ul {
  margin: 0;
  padding: 0;
  padding-left: 1.5rem;
}
li {
  display: inline-block;
  width: 14%;
  margin: 0;
}
</style>
